import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/utils/humanTime';

/**
 * The replies a story received, newest first. Shown to its author only — the
 * server sends replies with no one else's copy of the story.
 *
 * Attrs:
 *   replies – [{id, content, createdAt, user}]
 *   onuser  – callback(user), to open a replier's profile
 */
export default class StoryReplyList extends Component {
  view() {
    const replies = this.attrs.replies || [];

    return (
      <div className="StoryViewer-listSection">
        <div className="StoryViewer-listTitle">
          {app.translator.trans('happydigital-stories.forum.replies_list')}
        </div>

        {replies.length === 0 ? (
          <div className="StoryViewer-noViewers">
            {app.translator.trans('happydigital-stories.forum.no_replies')}
          </div>
        ) : (
          replies.map((reply) => this.item(reply))
        )}
      </div>
    );
  }

  item(reply) {
    const user = reply.user;
    const name = user.displayName || user.username;

    return (
      <div className="StoryViewer-viewerItem StoryViewer-replyItem" key={reply.id}>
        {user.avatarUrl ? (
          <img className="StoryViewer-avatar" src={user.avatarUrl} alt={name} />
        ) : (
          <div className="StoryViewer-avatarFallback">{(name || '?')[0].toUpperCase()}</div>
        )}

        <div className="StoryViewer-replyBody">
          <div className="StoryViewer-replyMeta">
            <a className="StoryViewer-username" onclick={() => this.attrs.onuser(user)}>
              {name}
            </a>
            <span className="StoryViewer-time">{humanTime(reply.createdAt)}</span>
          </div>
          {/* Plain text: a reply is never rendered as HTML. */}
          <div className="StoryViewer-replyText">{reply.content}</div>
        </div>
      </div>
    );
  }
}
